<template>
  <div class="WF_ToDoList">
    <div class="xdFlowRow"  v-for="(item,index) in todolist">
      <div class="xdFlowCell1">
        <ul class="xdFlowUL"><li>{{item.opuname?(item.opuname==item.targetuname?item.targetuname:(item.opuname+"【"+item.targetuname+"】")):item.targetuname}}</li>
          <li v-if="item.hddate">{{item.hddate}}</li>
          <li v-else style="color: #11CD6E;">处理中</li>
        </ul>
        <img class="yuandian_icon" :src="item.src">
      </div>
      <span class="xdspan">
        <span class="xdFlowBox1" :class="item.color">
          <el-input v-model="option" auto-complete="off" type="textarea" placeholder="请签署您的意见！" :row="2" v-if="item.allowEdit" style="font:400 13.3333px Arial;"></el-input>
          <span class="wddispName" v-else-if="item.op==''">无</span>
          <span v-else>{{item.op}}</span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
    export default {
      name: "WorkflowView",
      data() {
        return {
          todolist: [],
          option: "",
          allowEdit:false,
        }
      },
      methods: {
        getOption(){
          return this.option;
        },
        initData(todolist,FormAllowEdit) {
          if(todolist==null||todolist=='')
            todolist=[];
          this.option="";
          for(var i=0;i<todolist.length;i++) {
            switch (todolist[i].optype) {
              case 'pass':
                todolist[i]["src"] = "/static/img/pass.png";
                todolist[i]["color"] = "blue";
                break;
              case 'back':
                todolist[i]["src"] = "/static/img/back.png";
                todolist[i]["color"] = "red";
                break;
              case 'transmit':
                todolist[i]["src"] = "/static/img/zhuan.png";
                todolist[i]["color"] = "orange";
                break;
              default:
                todolist[i]["src"] = "/static/img/waithandle.png";
                todolist[i]["color"] = "green";
                if(FormAllowEdit&&todolist[i].hddate==null){
                  todolist[i]["allowEdit"]=true;
                  this.option=todolist[i].op;
                  if(this.option==null)
                    this.option='';
                }
                break;
            }
          }
          this.todolist = todolist;
        }
      }
    }
</script>

<style scoped>
  /*流程样式*/
  .xdFlowRow {
    width: 100%;
    min-height: 40px;
    position: relative;
    float: left;
  }

  .xdFlowCell1 {
    width: 25%;
    float: left;
    min-height: 40px;
    position: relative;
  }

  .xdFlowUL {
    position: absolute;
    top: 10px;
    right: 25px;
    text-align: right;
  }

  .yuandian_icon {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 5px;
    right: -24px;
  }

  .xdFlowBox1 {
    top: 20px;
    width: 100%;
    border-radius: 5px;
    padding: 5px 15px;
    float: left;
    margin-left: 20px;
    min-height: 30px;
    text-align: left;
  }

  .xdFlowRow .blank {
    border: 1px solid grey;
  }

  .xdFlowRow .blue {
    border: 1px solid #48B4FF;
  }


  .xdFlowRow .red {
    border: 1px solid red;
  }
  .xdFlowRow .green {
    border: 1px solid #11CD6E;
  }
  .xdFlowRow .orange {
    border: 1px solid #ffa500;
  }
  .xdspan {
    border-left: 1px solid #ccc;
    float: left;
    width: 65%;
    height: 100%;
    min-height: 40px;
    padding-top: 10px;
  }
  .wddispName{
    font-size: 12px;
    color: #656565;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/workflow/WorkflowView.vue